var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "city-intl-tabs",
              on: { "tab-click": _vm.onIntlTabClick },
              model: {
                value: _vm.activeIntlTab,
                callback: function ($$v) {
                  _vm.activeIntlTab = $$v
                },
                expression: "activeIntlTab",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "国内", name: "1" } }),
              _vm._v(" "),
              _c("el-tab-pane", { attrs: { label: "国际", name: "2" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              key: _vm.activeIntlTab,
              staticClass: "table",
              attrs: {
                border: true,
                data: _vm.tableData,
                size: "mini",
                "row-key": "cityId",
                "highlight-current-row": "",
                border: "",
                lazy: "",
                load: _vm.load,
                "header-cell-style": { fontWeight: "bold" },
                "tree-props": { children: "child", hasChildren: "hasChildren" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", "min-width": "250", label: "地区名称" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.formShow
            ? _c("parser", {
                attrs: {
                  "form-conf": _vm.formConf,
                  "form-edit-data": _vm.formData,
                  "is-edit": _vm.isCreate === 1,
                },
                on: { submit: _vm.submit },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }